import { setLocalization, initializeProgram, INITIALIZE_PROGRAM, SET_LOCALIZATION, IS_USER_LOGGED_IN,
  checkProjectsForNotFoundItems } from '../modules/app';

import { getUIText } from '../utils/index';

import { checkStatus, getMe, getProjects, getCustoms } from '../utils/user';

import { INITIAL_STATE } from '../modules/project';

import { patchUser } from '../modules/user';

import { addProject, setProjects } from '../modules/projects';

import { setCustomItems } from '../modules/data/customs';
import { adobePageLoad } from '../utils/analytics';


export function createMiddleware() {
  return store => next => action => {
    const {
      type,
      payload
    } = action;
    switch (type) {
      case SET_LOCALIZATION:
        next(action);
        break;

      case IS_USER_LOGGED_IN:
        // if(process.env.NODE_ENV === 'development') {
        //   store.dispatch(initializeProgram());
        // } else {
          checkStatus().then(() => {
            // if logged in set data to user and initializeProgram
            // set user language


/*             TODO: Set localization by user?

            store.dispatch(setLocalization({
              language: "testi",
              country: "testi"
            })) */

            getMe().then((result) => {
              console.log('RESULT:>>', result);
              // User info
              const me = result;
              let uuid;

              if(me) {
                let username;
                if(me.name) {
                  username = me.name;
                }

                let uid;
                if(me.uid) {
                  uid = me.uid;
                }

                if(me.uuid) {
                  uuid = me.uuid;
                }

                let user_lang = 'English';
                if(me.field_user_interface_language) {
                  user_lang = me.field_user_interface_language;
                }

                let user_country = 'Global';
                if(me.field_country_offering) {
                  user_country = me.field_country_offering;
                }

                if(me.logout_token) {
                  sessionStorage.setItem('logoutToken', me.logout_token);
                }

                if(username && uid && uuid) {
                  store.dispatch(setLocalization({
                    language: user_lang,
                    country: user_country
                  }));

                  store.dispatch(
                    patchUser({
                      username,
                      uid,
                      uuid
                    })
                  );
                }
              }

              // if user uuid is null, can´t get user projects or custom items
              if(!uuid) {
                Promise.reject(new Error('User uuid is: ' + uuid));
              }

              // adobePageLoad(window, document, me);

              Promise.all([
                getProjects(uuid),
                getCustoms(uuid),
              ]).then((result) => {
                // Projects
                const projects = result[0];
                if (projects) {
                  store.dispatch(
                    setProjects(projects)
                  );
                }

                // Custom items
                const customsItems = result[1];
                if (customsItems) {
                  store.dispatch(setCustomItems(customsItems));
                }

                if (payload && payload.success) {
                  store.dispatch(payload.success());
                } else {
                  store.dispatch(initializeProgram());
                }
              });
            });
          }).catch(function(error) {
            // adobePageLoad(window, document, null);

            if (payload && payload.success) {
              store.dispatch(payload.success());
            } else {
              store.dispatch(initializeProgram());
            }
          });
        // }

        break;

      case INITIALIZE_PROGRAM:

        console.log('*** INITIALIZE_PROGRAM ***');
        store.dispatch(checkProjectsForNotFoundItems());

        const {
          app,
          translations
        } = store.getState();

        const o = {
          ...INITIAL_STATE,
          name: getUIText('PROJECTS-DEFAULT_PROJECT_NAME', app.language, translations),
          title: getUIText('PROJECTS-DEFAULT_PROJECT_NAME', app.language, translations),
        };
        store.dispatch(addProject({
          'project': o
        }));
        next(action);
        break;

      default:
        next(action);
    }
  };
}
